import { NoDataContentWrapper, RenderDataWithFallback, NoDataContentWrapperProps } from '@anytag/shared-atoms';
import { SectionWithHeader, SectionWithHeaderProps } from '@anytag/shared-molecules';

export interface InfluencerProfileFeedPostsWrapperProps
  extends SectionWithHeaderProps,
    Pick<NoDataContentWrapperProps, 'dataNotAvailable' | 'wrapperLink' | 'wrapperText'> {
  loading?: boolean;
}

export const InfluencerProfileFeedPostsWrapper = ({
  loading,
  children,
  wrapperLink,
  wrapperText,
  dataNotAvailable,
  moreDetailProps,
  ...restProps
}: InfluencerProfileFeedPostsWrapperProps) => (
  <RenderDataWithFallback loading={loading}>
    <SectionWithHeader
      moreDetailProps={!dataNotAvailable ? moreDetailProps : undefined}
      css={{ borderRadius: 0, marginTop: '1px', minHeight: '220px', '.section-header': { borderBottom: 'none' } }}
      {...restProps}
    >
      <NoDataContentWrapper
        wrapperText={wrapperText}
        wrapperLink={wrapperLink}
        dataNotAvailable={dataNotAvailable}
        className="no-data-wrapper min-h-30 border-none"
      >
        {children}
      </NoDataContentWrapper>
    </SectionWithHeader>
  </RenderDataWithFallback>
);
